import { TS_ItemType } from './TS_ItemType';
import { TS_Addon }    from './TS_Addon';

export class TS_PaymentType extends TS_Addon {
    type = TS_ItemType.PAYMENT;
    imageURLs: string[];
    isWallet: boolean;
}